module.exports = __webpack_public_path__ + "static/media/CopyIcon.be6315ac.svg";